import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Pipe, PipeTransform, SimpleChanges } from '@angular/core';
import { ContentElement, ContentElementEnum, ContentEnum, ContentStatusEnum, Grid, GridCell, GridCellClass, GridOptions, KwikstoreSection, OrientationEnum, RowCell, Section, SectionData } from '../../models/sections-model';
import exportFromJSON from 'export-from-json';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Pipe({
  name: 'safeStyle'
})
export class SafeStylePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(value);
  }
}

@Component({
  selector: 'ngx-grid-renderer',
  templateUrl: './grid-renderer.component.html',
  styleUrls: ['./grid-renderer.component.scss']
})
export class GridRendererComponent implements OnInit,OnChanges {
  //@Input() data:Section;
  @Input() data:SectionData
  @Input() edit:boolean;
  /**
   *  CTNT_IN_PROGRESS = "In Progress",
    CTNT_INITIAL_DRAFT = "Initial Draft",
    CTNT_REVISED_DRAFT = "Revised Draft",
    CTNT_FINAL_DRAFT = "Final Draft",
    CTNT_PUBLISHED = "Published",
    CTNT_DEACTIVATED = "CTNT_DEACTIVATED"
   */
  @Input() status:ContentStatusEnum;
  @Input() preview:boolean = false;
  title:ContentElement;
  gridCells:GridCell[];
  numberOfElements:number;
  layoutClass:string;
  bgColor:string;
  border:string;
  borderRadius:string;

  selectedCell:GridCell | RowCell;

  wrapperClass:string;

  ContentEnum = ContentEnum;

  ContentElementEnum = ContentElementEnum;

  
  @Output() gridOptions: EventEmitter<GridOptions> = new EventEmitter<GridOptions>();
  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<GridCell>();
  host:HTMLElement;

  constructor(
    private el:ElementRef,
    private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.numberOfElements = this.data.numberOfElements;
     this.title = this.data.title;
    this.layoutClass = this.data.layoutClass?this.data.layoutClass:"grid-3";
    if(this.layoutClass == "GridLayoutEnum.GRID_9"){
      this.layoutClass = "grid-9";
    }
    if(this.layoutClass == "GridLayoutEnum.GRID_8"){
      this.layoutClass = "grid-8";
    }
    if(this.layoutClass == "GridLayoutEnum.GRID_7"){
      this.layoutClass = "grid-7";
    }
    if(this.layoutClass == "GridLayoutEnum.GRID_6"){
      this.layoutClass = "grid-6";
    }
    if(this.layoutClass == "GridLayoutEnum.GRID_5"){
      this.layoutClass = "grid-5";
    }
    if(this.layoutClass == "GridLayoutEnum.GRID_4"){
      this.layoutClass = "grid-4";
    }
    if(this.layoutClass == "GridLayoutEnum.GRID_3"){
      this.layoutClass = "grid-3";
    }
    this.wrapperClass = this.data.wrapperClass?this.data.wrapperClass:"solid";
    this.gridCells = this.data.gridOptions.gridCells;
    console.log(this.data);
    /* if(this.data.isPreview){
      this.preview = this.data.isPreview
    } */
    if(this.data.bgColor != undefined){
      this.bgColor = this.data.bgColor;
      console.log("bgColor: "+this.bgColor);
    }
    if(this.data.border != undefined){
      this.border = this.data.border;
      console.log("border: "+this.border);
    }
    if(this.data.borderRadius != undefined){
      this.borderRadius = this.data.borderRadius;
      console.log("borderRadius: "+this.borderRadius);
    }
    //this.setSpan(this.numberOfElements,this.data.variableImageSizes);
    this.host = this.el.nativeElement;
    //this.preview = this.data.isPreview?this.data.isPreview:false;
    console.log(this.preview);
    this.selectedCell = this.data.selectedCell?this.data.selectedCell:null;
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["data"]){
      console.log(this.data);
      console.log(this.edit)
      console.log({GridOptions:this.data})
      //this.status = this.data.status;
      if(this.data.bgColor != undefined){
        this.bgColor = this.data.bgColor;
        console.log("bgColor: "+this.bgColor);
      }
      if(this.data.border != undefined){
        this.border = this.data.border;
        console.log("border: "+this.border);
      }
      if(this.data.borderRadius != undefined){
        this.borderRadius = this.data.borderRadius;
        console.log("borderRadius: "+this.borderRadius);
      }
      if(this.data.title){
        this.title = this.data.title;
      }
      this.gridOptions.emit(this.data.gridOptions);
    }
    if(changes["edit"]){
      console.log(this.edit)
    }
    if(changes["preview"]){
      console.log(this.preview)
    }
  }

  updateSection(section:Section){
    console.log(section);
    this.data = section;
    this.gridCells = section.sectionData.gridOptions.gridCells;
    console.log(this.gridCells);
    this.cdr.detectChanges();
  }

  setSpan(numberOfElements,variableImageSizes){
    if(!variableImageSizes){
      if(12 % numberOfElements % 2 > 0){
        console.log("its something")
      }else{
        console.log("12 % numberOfElements: "+12 % numberOfElements+ " numberOfElements % 2: "+numberOfElements % 2);
        console.log("its something ELSE")
      }
    }
  }

  export(gridClass:string){
    let grid = (this.host.getElementsByClassName(gridClass))[0];
    let gridObject = {className:""};
    gridObject["className"] = gridClass;
    gridObject["display"] = getComputedStyle(grid).display;
    gridObject["gridTemplateColumns"] = getComputedStyle(grid).gridTemplateColumns;
    gridObject["gridTemplateRows"] = getComputedStyle(grid).gridTemplateRows;
    gridObject["gap"] = getComputedStyle(grid).gap;
    gridObject["cells"] = [];
    //console.log({display:getComputedStyle(grid).display});
    //console.log({gap:getComputedStyle(grid).gap});
    //console.log({gridTemplateColumns:getComputedStyle(grid).gridTemplateColumns});//gridTemplateColumns
    //console.log({gridTemplateRows:getComputedStyle(grid).gridTemplateRows});
    for(let i = 0;i < grid.children.length; i++){
      let cell:{} = {};
      let child = grid.children[i];
        let classList:DOMTokenList = child.classList;
        classList.forEach(cellClassName => {
          if(cellClassName.length == 1){
            cell["class"] = cellClassName;
          }
        });
        cell["gridRowStart"] = getComputedStyle(child).gridRowStart;
        cell["gridRowEnd"] = getComputedStyle(child).gridRowEnd;
        cell["gridColumnStart"] = getComputedStyle(child).gridColumnStart;
        cell["gridColumnEnd"] = getComputedStyle(child).gridColumnEnd;
        cell["width"] = getComputedStyle(child).width;
        cell["height"] = getComputedStyle(child).height;
        //gridColumnStart
        //gridColumnEnd
        //gridRow
        //gridRowStart
        //width
        //height
        gridObject["cells"].push(cell); 
    }
    const fileName = gridClass
    const exportType = 'json';
    let jsonData = JSON.stringify(gridObject, null, 2);
    jsonData.replace(/\\n/g, '');
    let data = {"gridDefinition":gridObject};
    console.log(data);
    exportFromJSON({ data, fileName, exportType });
    //console.log(gridObject);
  }
  /**
   * Listens to the click event on EditPlaceholderRendererComponent
   * @param cell The cell for which content will be created
   * Emits the cell through the createUpdate observable
   */
  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }



}
